import './home/home.css';
import { useEffect, useRef, useState } from 'react';

/* „Partnerek (affiliate)” (3a) — a korábban a figyelőlista alatt álló
   „Partnerek & kedvezmények” blokk, változatlan tartalommal, a láblécben.
   Kampányadat szándékosan nincs a csempéken (a számok a /bonusz oldalon élnek,
   ami a landing configjából generálódik). */
export default function PartnersMenu() {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return;
    const close = (e) => { if (!ref.current?.contains(e.target)) setOpen(false); };
    const esc = (e) => { if (e.key === 'Escape') setOpen(false); };
    window.addEventListener('mousedown', close); window.addEventListener('keydown', esc);
    return () => { window.removeEventListener('mousedown', close); window.removeEventListener('keydown', esc); };
  }, [open]);

  return (
    <div className="ptm" ref={ref}>
      <button type="button" className="ptm-btn" aria-haspopup="dialog" aria-expanded={open} onClick={() => setOpen(o => !o)}>
        🤝 Partnerek <span className="ptm-aff">(affiliate)</span>
      </button>
      {open && (
        <div className="ptm-panel prt-section" role="dialog" aria-label="Partnerek (affiliate)">
          <div className="ptm-title">Partnerek &amp; kedvezmények <span className="ptm-aff">· affiliate linkek</span></div>
          <div className="prt-cards">
            <a href="https://www.bybit.eu/hu-EU/promo/campaign/EU_affiliate_depositcampaign/?affiliate_id=83241"
              target="_blank" rel="noopener noreferrer sponsored" className="prt-card prt-bybit">
              <div className="prt-top"><span className="prt-name">🟡 Bybit EU</span></div>
              <div className="prt-sub">MiCA engedélyes · Osztrák szabályozás</div>
            </a>
            <a href="https://my.okx.com/de/campaigns/web-three-kurzus?channelId=72518582"
              target="_blank" rel="noopener noreferrer sponsored" className="prt-card prt-okx">
              <div className="prt-top"><span className="prt-name">⚫ OKX Europe</span></div>
              <div className="prt-sub">MiCA + MiFID II engedélyes</div>
            </a>
          </div>
          <a href="https://web3kurzus.hu/bonusz" target="_blank" rel="noopener noreferrer" className="prt-bonusz-link">Aktuális bónuszok →</a>
          <div className="prt-divider" />
          <a href="https://linktr.ee/drkripto" target="_blank" rel="noopener noreferrer sponsored" className="prt-linktree">
            <span className="prt-lt-icon">🔗</span>
            <div className="prt-lt-text">
              <span className="prt-lt-main">További kedvezmények</span>
              <span className="prt-lt-sub">linktr.ee/drkripto</span>
            </div>
          </a>
        </div>
      )}
    </div>
  );
}
